const Bulb = () => (
  <>
    <path
      fill="currentColor"
      d="M12 21.154q-.69 0-1.201-.463a1.85 1.85 0 0 1-.607-1.152h3.616q-.097.69-.607 1.152a1.73 1.73 0 0 1-1.201.463m-2.5-3.385a.48.48 0 0 1-.357-.143.48.48 0 0 1-.143-.357q0-.213.143-.356a.48.48 0 0 1 .357-.144h5q.213 0 .357.144a.48.48 0 0 1 .143.356.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143zM8.558 15a6.9 6.9 0 0 1-2.238-2.356Q5.5 11.217 5.5 9.5q0-2.721 1.89-4.61T12 3t4.61 1.89T18.5 9.5q0 1.718-.82 3.144A6.9 6.9 0 0 1 15.442 15zm.292-1h6.3a5.55 5.55 0 0 0 1.737-1.975A5.4 5.4 0 0 0 17.5 9.5q0-2.3-1.6-3.9T12 4 8.1 5.6 6.5 9.5q0 1.35.612 2.525A5.55 5.55 0 0 0 8.85 14"
    />
  </>
)
export default Bulb
